import './HeaderComponent.css';
import Grow from '@mui/material/Grow';

function Header() {
    return (
        <header className="App-header">
            <Grow in={true}>
                <div className="App-Sobre_mi">
                    <h1>Logo</h1>
                </div>
            </Grow>
        </header>
    );
}

export default Header;